import React from 'react';
import { Image } from 'react-bootstrap';
import Button from '../Shared/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/Shared/SubmitQueryModal.css';
import success from '../../Assets/TruckVisits/Assets-Desktop/checked.svg';
import RespModal from '../Shared/RespModal';
function SubmitQueryModal(props) {
    return(
         <RespModal hasOpen={props.hasOpen}  >
        <div className="submitquerymodalsize" >
            <Image src={success} height="50" width="50" /><br /><br /> 
            <div id="submitquerymodalcontainsuccess">
                 {props.children}
            </div>
            <Button
                id="submitqueryresploginbutton"
                type="button"
                class="btn btn-dark"
                onClick={props.onCloseModal}
            >OK
        </Button><br /><br />
        </div>
     </RespModal> 
    );
}
export default SubmitQueryModal; 